import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { generateChecksum } from '../middleware/generateChecksum';

export const businessApi = createApi({
    reducerPath: 'businessApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL + '/v2/api/',
    }),
    endpoints: (builder) => ({
        submitBusinessDetails: builder.mutation({
            query: (data) => {
                const body = {
                    mode: 'submit-bussiness-details',
                    document_name: data.document_name, // eg. 'udyam_registration_number',
                    document_number: data.docTypeNumber,
                    file: data.fileData
                }
                const checksum = generateChecksum(body)
                body.checksum = checksum

                return {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        Accept: 'application/json',
                        secret: data.scrt,
                        jwt_token: data.jwt_token,
                    },
                    body: new URLSearchParams(body).toString(),
                };
            },
        }),
        skipPage: builder.mutation({
            query: (data) => {
                const body = new URLSearchParams({
                    mode: 'skip_page',
                    page : data.page,
                    checksum: generateChecksum({ mode: 'skip_page', page : data.page }),
                }).toString();

                return {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        secret: data.scrt,
                        jwt_token: data.jwt_token,
                    },
                    body,
                };
            },
        })
    }),
});

export const {
    useSubmitBusinessDetailsMutation,
    useSkipPageMutation
} = businessApi;
